import { render, staticRenderFns } from "./KnownActionTranslations.vue?vue&type=template&id=0eed5636&"
import script from "./KnownActionTranslations.vue?vue&type=script&lang=js&"
export * from "./KnownActionTranslations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports